import React from 'react';
import tw from 'twin.macro';
import { capitalize, strippedContent, formatNumber } from '../../lib/helpers';
import { Title, Paragraph, Small } from '../text';
import { ItemActions } from './';
import { useHydrationSafeDate } from '../common/hooks';

export const ItemSummary = ({ item, isSidebar, isDetailPage }) => {
  const { title, description, date, stats } = item;
  const hydrationSafeDate = useHydrationSafeDate(date, true);

  const desc = isDetailPage
    ? description.replaceAll('<p>', '').replaceAll('</p>', '</br>')
    : strippedContent(description);

  return (
    <>
      <div tw='flex'>
        <div tw='flex-grow'>
          <Title
            Type={isDetailPage ? 'h1' : 'h2'}
            regular={isDetailPage}
            css={[
              !isDetailPage && tw`line-clamp-2 text-base md:text-base font-bold normal-case`,
              isDetailPage && tw`normal-case font-bold`,
              isSidebar && tw`text-light line-clamp-2`,
            ]}
            marginBottom={false}
          >
            {capitalize(title || '')}
          </Title>
          <Paragraph
            dangerouslySetInnerHTML={{ __html: desc.replace(/\s+/g, ' ') }}
            css={[
              !isDetailPage && tw`line-clamp-1 break-all`,
              isDetailPage && { wordBreak: 'break-word' },
            ]}
          />
        </div>
        <ItemActions item={item} />
      </div>
      <Small tw='line-clamp-1 flex-shrink-0 w-full whitespace-nowrap'>
        {hydrationSafeDate} | {formatNumber(stats.views_total)} views
        {isDetailPage && ` (${formatNumber(stats.views_today)} views vandaag)`}
      </Small>
    </>
  );
};
